<template>
  <shopmall-tip
    location="end"
    color="#00000099"
    icon="mdi-help-circle-outline"
    message="By selecting this option, we will send you a physical sample after pre-production."
  >
  </shopmall-tip>
</template>

<script setup></script>

<style lang="scss">
.tips {
}
</style>
